import { createSlice } from '@reduxjs/toolkit';

const initialState = [];

const dealersSlice = createSlice({
    name: 'dealers',
    initialState,
    reducers: {
        setDealers: (state, action) => {
            return action.payload;
        },
        removeDealers: () => {
            return initialState;
        },
    },
});

export const { setDealers, removeDealers } = dealersSlice.actions;
export default dealersSlice.reducer;